import { api } from "@/builders/axios";
import { SuggestedCoursesData } from "@/builders/types/course";

const suggested_courses = () => {
  return api
    .get<{
      data: SuggestedCoursesData[];
    }>("/courses/others/suggested-courses")
    .then(({ data }) => data);
};

export const others = {
  suggested_courses,
};
